import styled, { css, keyframes } from 'styled-components';

const textParagraphSmSemi = css`
  font-size: 0.875rem;
  line-height: 150%;
  font-weight: 600;
`;

const textParagraphSmRegular = css`
  font-size: 0.875rem;
  line-height: 150%;
  font-weight: 400;
`;

const textParagraphXsRegular = css`
  font-size: 0.75rem;
  line-height: 150%;
  font-weight: 400;
`;

export const FileInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FileInputLabel = styled.label<{ colorLabel?: string }>`
  ${textParagraphSmSemi}
  margin-bottom: 0.5rem;
  color: ${({ colorLabel }) => colorLabel || 'var(--text-title, #080404)'};
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const DropZone = styled.div<{ hasError?: boolean; isDragging?: boolean; disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 1.5rem 1rem;
  border: 2px dashed ${({ hasError, isDragging }) => {
    if (hasError) return '#F3322B';
    if (isDragging) return '#3754e2';
    return 'var(--general-border, #e2e8f0)';
  }};
  border-radius: 8px;
  background: ${({ isDragging }) => isDragging ? '#f0f4ff' : '#fafafa'};
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  opacity: ${({ disabled }) => disabled ? 0.6 : 1};
  transition: border-color 0.2s, background 0.2s;

  &:hover {
    border-color: ${({ hasError, disabled }) => {
      if (disabled) return undefined;
      if (hasError) return '#F3322B';
      return '#3754e2';
    }};
    background: ${({ disabled }) => disabled ? undefined : '#f0f4ff'};
  }
`;

export const UploadIcon = styled.div`
  color: #94a3b8;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DropZoneText = styled.p`
  ${textParagraphSmRegular}
  color: #64748B;
  text-align: center;
  margin: 0;

  strong {
    color: #3754e2;
    font-weight: 600;
    cursor: pointer;
  }
`;

export const AcceptedFormats = styled.span`
  ${textParagraphXsRegular}
  color: #94a3b8;
`;

export const FilePreview = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  background: #f8fafc;
  border: 1px solid var(--general-border, #e2e8f0);
  border-radius: 8px;
  margin-top: 0.5rem;
`;

export const FileIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748B;
  flex-shrink: 0;
`;

export const FileInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;

export const FileName = styled.p`
  ${textParagraphSmRegular}
  color: #0f172a;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const UploadStatus = styled.span<{ status: 'uploading' | 'success' | 'error' }>`
  ${textParagraphXsRegular}
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: ${({ status }) => {
    if (status === 'uploading') return '#64748B';
    if (status === 'success') return '#16a34a';
    return '#F3322B';
  }};
`;

export const SpinnerIcon = styled.span`
  display: inline-flex;
  animation: ${spin} 1s linear infinite;
`;

export const RemoveButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  flex-shrink: 0;

  &:hover {
    color: #F3322B;
    background: #fef2f2;
  }
`;

export const ErrorText = styled.p`
  ${textParagraphXsRegular}
  margin-top: 0.25rem;
  color: #F3322B;
`;
